/* tslint:disable */
/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root 
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { SocketBrowser } from './sockets/socket.browser';
import { SocketDriver } from './sockets/socket.driver';
import { SocketConnection } from './sockets/socket.connections';
import { RealTime } from './services/core/real.time';
import { UserApi } from './services/custom/User';
import { AccessTokenApi } from './services/custom/AccessToken';
import { ACLApi } from './services/custom/ACL';
import { RoleMappingApi } from './services/custom/RoleMapping';
import { RoleApi } from './services/custom/Role';
import { RootAccountApi } from './services/custom/RootAccount';
import { ChartOfAccountApi } from './services/custom/ChartOfAccount';
import { UserProfileApi } from './services/custom/UserProfile';
import { CompanyAssetApi } from './services/custom/CompanyAsset';
import { CompanyAccountApi } from './services/custom/CompanyAccount';
import { AppPropertiesApi } from './services/custom/AppProperties';
import { PropertyUnitsApi } from './services/custom/PropertyUnits';
import { PropertyTypeApi } from './services/custom/PropertyType';
import { CountryApi } from './services/custom/Country';
import { PropertyBankApi } from './services/custom/PropertyBank';
import { BankingApi } from './services/custom/Banking';
import { PropertyOwnerApi } from './services/custom/PropertyOwner';
import { PropertyCaretakerApi } from './services/custom/PropertyCaretaker';
import { ManagementFeeSettingsApi } from './services/custom/ManagementFeeSettings';
import { StorageSettingsApi } from './services/custom/StorageSettings';
import { TenantUnitApi } from './services/custom/TenantUnit';
import { PropertyPropertyTypeApi } from './services/custom/PropertyPropertyType';
import { PropertyDetailsApi } from './services/custom/PropertyDetails';
import { MeterReadingApi } from './services/custom/MeterReading';
import { UnitFeatureApi } from './services/custom/UnitFeature';
import { PropertyUnitFeatureApi } from './services/custom/PropertyUnitFeature';
import { CheckListApi } from './services/custom/CheckList';
import { TenantCheckListApi } from './services/custom/TenantCheckList';
import { FileStorageApi } from './services/custom/FileStorage';
import { FileManagerApi } from './services/custom/FileManager';
import { LeaseApi } from './services/custom/Lease';
import { IncomeInvoiceApi } from './services/custom/IncomeInvoice';
import { PaymentMethodsApi } from './services/custom/PaymentMethods';
import { TenantDepositApi } from './services/custom/TenantDeposit';
import { PropertyFileApi } from './services/custom/PropertyFile';
import { PropertyUnitFileApi } from './services/custom/PropertyUnitFile';
import { ProfileFileApi } from './services/custom/ProfileFile';
import { SettingsTenantApi } from './services/custom/SettingsTenant';
import { VendorCategoriesApi } from './services/custom/VendorCategories';
import { WorkOrderApi } from './services/custom/WorkOrder';
import { HouseInspectionApi } from './services/custom/HouseInspection';
import { InspectionRoomApi } from './services/custom/InspectionRoom';
import { PenaltyChargeApi } from './services/custom/PenaltyCharge';
import { InspectionFileApi } from './services/custom/InspectionFile';
import { IncomeExpenditureApi } from './services/custom/IncomeExpenditure';
import { TenantLeaseApi } from './services/custom/TenantLease';
import { ExpenditureApi } from './services/custom/Expenditure';
import { LeaseArchiveApi } from './services/custom/LeaseArchive';
import { WorkOrderExpensesApi } from './services/custom/WorkOrderExpenses';
import { DepositTypeApi } from './services/custom/DepositType';
import { FeeApi } from './services/custom/Fee';
import { TenantFeeApi } from './services/custom/TenantFee';
import { VendorPaymentsApi } from './services/custom/VendorPayments';
import { BillsPaymentsApi } from './services/custom/BillsPayments';
import { RecurringChargeApi } from './services/custom/RecurringCharge';
import { LandlordDetailsApi } from './services/custom/LandlordDetails';
import { LandlordPropertiesApi } from './services/custom/LandlordProperties';
import { TempLeaseRenewalApi } from './services/custom/TempLeaseRenewal';
import { ReferenceApi } from './services/custom/Reference';
import { CreditNoteApi } from './services/custom/CreditNote';
import { PropertyEventsApi } from './services/custom/PropertyEvents';
import { VerificationCodeApi } from './services/custom/VerificationCode';
import { TenantExitTempApi } from './services/custom/TenantExitTemp';
import { LandlordPayoutApi } from './services/custom/LandlordPayout';
import { RequisiteCostsApi } from './services/custom/RequisiteCosts';
import { RemittanceReportSettingsApi } from './services/custom/RemittanceReportSettings';
import { PaymentEntriesApi } from './services/custom/PaymentEntries';
import { TenantPaymentsApi } from './services/custom/TenantPayments';
import { InvoicePaymentEntryApi } from './services/custom/InvoicePaymentEntry';
import { IncomeInvoiceEditMemoApi } from './services/custom/IncomeInvoiceEditMemo';
import { PaymentReversalMemoApi } from './services/custom/PaymentReversalMemo';
import { PropertySettlementApi } from './services/custom/PropertySettlement';
import { TenantLeaseEventsModelApi } from './services/custom/TenantLeaseEventsModel';
import { InvoiceRefundApi } from './services/custom/InvoiceRefund';
import { LeaseTerminationApi } from './services/custom/LeaseTermination';
import { LeaseRenewTempApi } from './services/custom/LeaseRenewTemp';
import { PropertyBadDebtApi } from './services/custom/PropertyBadDebt';
import { MeterReadingEntryApi } from './services/custom/MeterReadingEntry';
import { PropertyBillsApi } from './services/custom/PropertyBills';
import { PropertyBillsEditMemoApi } from './services/custom/PropertyBillsEditMemo';
import { LeaseReviewHistoryApi } from './services/custom/LeaseReviewHistory';
import { DiscountApi } from './services/custom/Discount';
import { LandlordChartOfAccountApi } from './services/custom/LandlordChartOfAccount';
import { DigitaxActionsApi } from './services/custom/DigitaxActions';
import { BulkSMSApi } from './services/custom/BulkSMS';
import { BulkSMSRecipientApi } from './services/custom/BulkSMSRecipient';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler,
    SocketConnection
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        LoopBackAuth,
        LoggerService,
        SDKModels,
        RealTime,
        UserApi,
        AccessTokenApi,
        ACLApi,
        RoleMappingApi,
        RoleApi,
        RootAccountApi,
        ChartOfAccountApi,
        UserProfileApi,
        CompanyAssetApi,
        CompanyAccountApi,
        AppPropertiesApi,
        PropertyUnitsApi,
        PropertyTypeApi,
        CountryApi,
        PropertyBankApi,
        BankingApi,
        PropertyOwnerApi,
        PropertyCaretakerApi,
        ManagementFeeSettingsApi,
        StorageSettingsApi,
        TenantUnitApi,
        PropertyPropertyTypeApi,
        PropertyDetailsApi,
        MeterReadingApi,
        UnitFeatureApi,
        PropertyUnitFeatureApi,
        CheckListApi,
        TenantCheckListApi,
        FileStorageApi,
        FileManagerApi,
        LeaseApi,
        IncomeInvoiceApi,
        PaymentMethodsApi,
        TenantDepositApi,
        PropertyFileApi,
        PropertyUnitFileApi,
        ProfileFileApi,
        SettingsTenantApi,
        VendorCategoriesApi,
        WorkOrderApi,
        HouseInspectionApi,
        InspectionRoomApi,
        PenaltyChargeApi,
        InspectionFileApi,
        IncomeExpenditureApi,
        TenantLeaseApi,
        ExpenditureApi,
        LeaseArchiveApi,
        WorkOrderExpensesApi,
        DepositTypeApi,
        FeeApi,
        TenantFeeApi,
        VendorPaymentsApi,
        BillsPaymentsApi,
        RecurringChargeApi,
        LandlordDetailsApi,
        LandlordPropertiesApi,
        TempLeaseRenewalApi,
        ReferenceApi,
        CreditNoteApi,
        PropertyEventsApi,
        VerificationCodeApi,
        TenantExitTempApi,
        LandlordPayoutApi,
        RequisiteCostsApi,
        RemittanceReportSettingsApi,
        PaymentEntriesApi,
        TenantPaymentsApi,
        InvoicePaymentEntryApi,
        IncomeInvoiceEditMemoApi,
        PaymentReversalMemoApi,
        PropertySettlementApi,
        TenantLeaseEventsModelApi,
        InvoiceRefundApi,
        LeaseTerminationApi,
        LeaseRenewTempApi,
        PropertyBadDebtApi,
        MeterReadingEntryApi,
        PropertyBillsApi,
        PropertyBillsEditMemoApi,
        LeaseReviewHistoryApi,
        DiscountApi,
        LandlordChartOfAccountApi,
        DigitaxActionsApi,
        BulkSMSApi,
        BulkSMSRecipientApi,
        internalStorageProvider,
        { provide: SDKStorage, useClass: StorageBrowser },
        { provide: SocketDriver, useClass: SocketBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';

